import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { MakeListComponent } from './components/list/make-list.component';
import { MakeAddDialogComponent } from './components/make-add-dialog/make-add-dialog.component';
import { MakeRoutingModule } from './make-routing.module';
import { MakeService } from './service/make.service';

@NgModule({
  imports: [CommonModule, SharedModule, MakeRoutingModule],
  declarations: [MakeListComponent, MakeAddDialogComponent],
  exports: [],
  providers: [MakeService],
  entryComponents: [MakeAddDialogComponent]
})
export class MakeModule {}
